import styled, { createGlobalStyle, css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledFloatingMenuGlobal = createGlobalStyle`
  ${({ theme }) => {
    return css`
      & .palette-floating-menu .palette-floating-menu-inner {
        padding: ${utils.rem(theme.Spacing.Size.XXSmall)} !important;
        border-radius: ${utils.rem(theme.Spacing.Size.XSmall)} !important;
        background-color: ${theme.Color.Neutrals.Paper} !important;
      }
    `;
  }}
`;

export const StyledFloatingMenu = styled.div`
  ${({ theme }) => {
    return css`
      & .ant-menu-item {
        display: flex !important;
        align-items: center;
        border-radius: ${utils.rem(theme.Spacing.Size.XXSmall)} !important;
        padding: ${utils.rem(theme.Spacing.Size.XXSmall)} ${utils.rem(theme.Spacing.Size.Small)} !important;

        & i {
          line-height: 0;
        }
      }
    `;
  }}
`;
